export enum AppErrorCode {
  UNKNOWN = "APP::UNKNOWN_ERROR",
  RUNTIME = "APP::RUNTIME_ERROR",
  DATABASE = "APP::DATABASE_ERROR",
  CONTENTION = "APP::CONTENTION_ERROR",
}
